import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { consumeAppMagicLink } from '../api/appMagicLinkApi';
import '../styles/AppMagicLinkPage.css';

export default function AppMagicLinkPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const run = async () => {
      if (!token) {
        setError('Invalid or missing login link token.');
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setError('');
        await consumeAppMagicLink({ token });
        setSuccess(true);

        setTimeout(() => {
          try {
            if (window.opener) {
              window.close();
            }
          } catch {
            // ignore
          }
        }, 900);
      } catch (e) {
        setError(e?.message || 'This login link is invalid or expired.');
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [token]);

  return (
    <div className="appMagicLink">
      <div className="appMagicLink__card">
        <h1 className="appMagicLink__title">
          {loading ? 'Verifying login link…' : success ? 'Success' : 'Login link'}
        </h1>
        <p className="appMagicLink__text">
          {loading
            ? 'Please wait while we verify your login link.'
            : error
              ? 'We could not verify this link.'
              : success
                ? 'You can close this tab now. Your original login page should sign you in automatically.'
                : 'You can close this tab.'}
        </p>

        {error ? (
          <div className="appMagicLink__alert" role="alert">
            {error}
          </div>
        ) : null}

        {loading ? <div className="appMagicLink__spinner" aria-hidden="true" /> : null}

        {!success ? (
          <button
            type="button"
            className="appMagicLink__btn"
            onClick={() => navigate('/app/login', { replace: true })}
            disabled={loading}
          >
            Back to login
          </button>
        ) : null}
      </div>
    </div>
  );
}
